var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPoundIcon = function SvgPoundIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9434 38.1199C30.4368 38.1199 38.9434 29.6133 38.9434 19.1199C38.9434 8.62646 30.4368 0.119873 19.9434 0.119873C9.44995 0.119873 0.943359 8.62646 0.943359 19.1199C0.943359 29.6133 9.44995 38.1199 19.9434 38.1199ZM27.359 24.0484H18.7262V20.323H24.7293V17.2893H18.7262V17.0232C18.7262 15.8524 19.0715 14.9742 19.7621 14.3888C20.4704 13.7856 21.4798 13.484 22.7902 13.484C24.2069 13.484 25.4111 13.7767 26.4027 14.3622L27.9434 10.3174C26.509 9.51903 24.7027 9.11987 22.5246 9.11987C19.6559 9.11987 17.4246 9.82062 15.8309 11.2221C14.2548 12.6236 13.4668 14.5928 13.4668 17.1297V17.2893H10.9434V20.323H13.4668V24.0484H10.9434V28.1199H27.359V24.0484Z",
    fill: "#0A9828"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPoundIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pound-icon.89b222b2a5aa1a93e5c30cf70b185794.svg";